import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://bzeesziulthbqojpebrq.supabase.co';
const SUPABASE_KEY = 'sb_publishable_PAIHnZ5WWUiq6LDQ1GDnfw_Pp02kh61';

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);